<template>
    <div class="chat-message" :class="`chat-message--${message.role}`">
        <div
            v-if="message.role === 'assistant' || message.role === 'error'"
            class="chat-message__avatar"
        >
            <nw-icon :icon="message.role === 'error' ? 'alert-octagon-outline' : 'robot-outline'" />
        </div>

        <div v-if="message.role === 'user'" class="chat-message__bubble">
            {{ message.content }}
        </div>
        <div
            v-else-if="message.role === 'assistant'"
            class="chat-message__bubble chat-message__bubble--markdown"
            v-html="renderedContent"
        />
        <div v-else class="chat-message__bubble">
            {{ message.content }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import MarkdownIt from 'markdown-it';
import type { Message } from '@/types/chat';

defineOptions({
    name: 'ChatMessage',
});

const props = defineProps<{ message: Message }>();

const md = new MarkdownIt({ html: false, linkify: true, typographer: true });

const renderedContent = computed(() => md.render(props.message.content));
</script>
